import { render, staticRenderFns } from "./JKQXSQ.vue?vue&type=template&id=df224162&scoped=true"
import script from "./JKQXSQ.vue?vue&type=script&lang=js"
export * from "./JKQXSQ.vue?vue&type=script&lang=js"
import style0 from "./JKQXSQ.vue?vue&type=style&index=0&id=df224162&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df224162",
  null
  
)

export default component.exports